import { UserProfileButtonConnected } from "../../UserProfileButton"
import { UserProgressConnected } from "../../UserProgress"
import { Widget } from "../../Widget/Widget"
import { UserFiltersConnected } from "./UserFilters"

import s from "./UserWidget.module.scss"

export const UserWidget = ({ showFilters }: { showFilters?: boolean }) => {
  return (
    <Widget>
      <UserWidget.Wrapper>
        <UserProfileButtonConnected />
        <UserProgressConnected />
        {showFilters && <UserFiltersConnected />}
      </UserWidget.Wrapper>
    </Widget>
  )
}

UserWidget.Wrapper = ({ children }: { children: React.ReactNode }) => (
  <div className={s.userWidget}>{children}</div>
)
